// @flow
import React from 'react';
import classNames from 'classnames';
import './TextAreaFormInput.css';

export type Props = {
  input: any,
  label: string,
  type: string,
  meta: any,
};

const TextAreaFormInput = ({input, label, meta: {touched, error}}: Props) => (
  <div className="TextAreaFormInput">
    <label className={classNames({'is-invalid-label': touched && error})}>
      {label}
    </label>
    <div>
      <textarea
        {...input}
        onChange={e => input.onChange(e.target.value)}
        placeholder={label}
        className={classNames({'is-invalid-input': touched && error})}/>
      {touched && error &&
        <span className="form-error is-visible">{error}</span>
      }
    </div>
  </div>
);

export default TextAreaFormInput;



// WEBPACK FOOTER //
// ./src/components/TextAreaFormInput/TextAreaFormInput.js